import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const url = req.url;

        if (url.indexOf('auth/token-auth') === -1 && url.indexOf('geocoder') === -1 && url.indexOf('route.cit.api') === -1 && url.indexOf('v1/token') === -1) {
            // Get the auth token from the service.
            const authToken = 'Bearer ' + sessionStorage.getItem('LOGICHECK.token');
            // const authToken = sessionService.getItem('LOGICHECK.token');
            const authReq = req.clone({setHeaders: {Authorization: authToken}});

            // send cloned request with header to the next handler.
            return next.handle(authReq);
        }
        return next.handle(req);
    }
}
